import { DateTime } from 'luxon';

export type EVENT_STATUS = {
    eventStatus: EVENT_PROCESS;
    eventEndAt: string;
    eventStartAt: string;
    earlyClosedAt: string | null;
};

export enum EVENT_PROCESS {
    NOT_OPENED = 'NOT-OPENED',
    EARLY_CLOSED = 'EARLY-CLOSED',
    EXPIRED = 'EXPIRED',
    IN_PROGRESS = 'IN-PROGRESS',
}

export type TICKET_STATUS = 'NO-TICKET' | 'UNUSED' | 'USED';
export type TICKET_PRIZE = 'INVALID' | 'FIRST' | 'EARLY-CLOSED';
export type TICKET_VERIFICATION = 'INVALID' | 'UNIDENTIFIED' | 'VERIFIED';
export type TICKET_VERIFICATION_RESULT = 'INVALID' | 'UNIDENTIFIED' | 'NOT-ADULT' | 'ALREADY-REGISTERED' | 'CONFIRMED';

// 개별 응모권 (GET /event/tickets의 eventResults 항목)
export type TICKET_ITEM = {
    clientId: number;
    ticketStatus: TICKET_STATUS;
    candyColor: TICKET_PRIZE;
    verificationStatus: TICKET_VERIFICATION;
    verificationResult: TICKET_VERIFICATION_RESULT;
    // 서버 기준 이벤트 신청 자격 보유 여부
    eligible: boolean | null;
};

// GET /event/tickets 응답. 1인 1회 이벤트라 eventResults는 최대 한 건만 의미를 갖는다
// (응모권 미보유 시에도 ticketStatus: 'NO-TICKET' 행이 하나 내려옴)
export type TICKET = {
    eventResults: TICKET_ITEM[];
};

export const expiredEvent: EVENT_STATUS = {
    eventStatus: EVENT_PROCESS.EXPIRED,
    eventStartAt: '',
    eventEndAt: '',
    earlyClosedAt: '2025-11-18T16:11:00',
};

// 조회 실패 폴백 — 응모권 없음으로 취급
export const expiredTicket: TICKET = {
    eventResults: [],
};

export const completelyExpiredDate = DateTime.fromISO('2027-07-15T00:00:00');

// 이벤트 시작 전
export const sampleEvent1: EVENT_STATUS = {
    eventStatus: EVENT_PROCESS.NOT_OPENED,
    eventStartAt: new Date('2025-07-02').toISOString(),
    eventEndAt: new Date('2025-07-07').toISOString(),
    earlyClosedAt: null,
};

// 이벤트 진행 중
export const sampleEvent2: EVENT_STATUS = {
    eventStatus: EVENT_PROCESS.IN_PROGRESS,
    eventStartAt: new Date('2025-06-25').toISOString(),
    eventEndAt: new Date('2025-07-05').toISOString(),
    earlyClosedAt: null,
};

// 이벤트 조기 마감 (배너 출력 시간(자정) 지나지 않음)
export const sampleEvent3: EVENT_STATUS = {
    eventStatus: EVENT_PROCESS.EARLY_CLOSED,
    eventStartAt: new Date('2025-06-25').toISOString(),
    eventEndAt: new Date('2025-07-05').toISOString(),
    earlyClosedAt: new Date('2025-07-02').toISOString(),
};

// 이벤트 종료 - 7일 이내
export const sampleEvent4: EVENT_STATUS = {
    eventStatus: EVENT_PROCESS.EXPIRED,
    eventStartAt: new Date('2025-06-15').toISOString(),
    eventEndAt: new Date('2025-06-25').toISOString(),
    earlyClosedAt: null,
};

// 이벤트 종료 - 7일 이후
export const sampleEvent5: EVENT_STATUS = {
    eventStatus: EVENT_PROCESS.EXPIRED,
    eventStartAt: new Date('2025-06-09').toISOString(),
    eventEndAt: new Date('2025-06-19').toISOString(),
    earlyClosedAt: null,
};

// 이벤트 종료 - 30일 이후
export const sampleEvent6: EVENT_STATUS = {
    eventStatus: EVENT_PROCESS.EXPIRED,
    eventStartAt: new Date('2025-04-15').toISOString(),
    eventEndAt: new Date('2025-04-25').toISOString(),
    earlyClosedAt: null,
};

// 티켓이 없는 상태
export const sampleTicket1: TICKET_ITEM = {
    clientId: 0,
    ticketStatus: 'NO-TICKET',
    candyColor: 'INVALID',
    verificationStatus: 'INVALID',
    verificationResult: 'INVALID',
    eligible: null,
};

// 티켓 존재 - 사용X
export const sampleTicket2: TICKET_ITEM = {
    clientId: 0,
    ticketStatus: 'UNUSED',
    candyColor: 'INVALID',
    verificationStatus: 'INVALID',
    verificationResult: 'INVALID',
    eligible: true,
};

// 티켓 존재 - 사용O, 조기마감
export const sampleTicket3: TICKET_ITEM = {
    clientId: 0,
    ticketStatus: 'USED',
    candyColor: 'EARLY-CLOSED',
    verificationStatus: 'INVALID',
    verificationResult: 'INVALID',
    eligible: true,
};

// 티켓 존재 - 사용O, 미인증
export const sampleTicket4: TICKET_ITEM = {
    clientId: 0,
    ticketStatus: 'USED',
    candyColor: 'FIRST',
    verificationStatus: 'UNIDENTIFIED',
    verificationResult: 'UNIDENTIFIED',
    eligible: true,
};

// 티켓 존재 - 사용O, 인증
export const sampleTicket5: TICKET_ITEM = {
    clientId: 0,
    ticketStatus: 'USED',
    candyColor: 'FIRST',
    verificationStatus: 'VERIFIED',
    verificationResult: 'CONFIRMED',
    eligible: true,
};

// 티켓 존재 - 사용O, 인증O, 중복 인증
export const sampleTicket6: TICKET_ITEM = {
    clientId: 0,
    ticketStatus: 'USED',
    candyColor: 'FIRST',
    verificationStatus: 'VERIFIED',
    verificationResult: 'ALREADY-REGISTERED',
    eligible: true,
};

// 티켓 존재 - 사용O, 인증O, 미성년자
export const sampleTicket7: TICKET_ITEM = {
    clientId: 0,
    ticketStatus: 'USED',
    candyColor: 'FIRST',
    verificationStatus: 'VERIFIED',
    verificationResult: 'NOT-ADULT',
    eligible: true,
};

// 신청 자격 없음 (eligible: false)
export const sampleTicket8: TICKET_ITEM = {
    clientId: 0,
    ticketStatus: 'UNUSED',
    candyColor: 'INVALID',
    verificationStatus: 'VERIFIED',
    verificationResult: 'CONFIRMED',
    eligible: false,
};
